import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const [orderNo, setOrderNo] = useState("");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let active = true;
    const poll = async () => {
      if (!active) return;
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setOrderNo(data.order_number);
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (e) { console.error("payment status poll failed", e); }
      if (attempts.current >= 8) { setStatus("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
  }, [sessionId, clear]);

  return (
    <div className="mx-auto max-w-2xl px-4 py-32 text-center">
      {status === "checking" && (<><Loader2 size={48} className="mx-auto text-brand-red animate-spin" /><h1 className="font-heading text-3xl font-extrabold mt-6">Vérification du paiement…</h1></>)}
      {status === "paid" && (<>
        <CheckCircle2 size={56} className="mx-auto text-green-500" />
        <h1 className="font-heading text-4xl font-extrabold mt-6" data-testid="payment-success">Merci pour votre commande !</h1>
        {orderNo && <p className="text-gray-500 mt-3">Commande <span className="font-semibold">{orderNo}</span></p>}
        <p className="text-gray-500 mt-2">Un courriel de confirmation vous sera envoyé. Notre équipe vous contactera pour la livraison.</p>
        <Link to="/boutique" className="inline-block mt-8 bg-brand-red text-white px-8 py-4 font-semibold">Continuer mes achats</Link>
      </>)}
      {status === "pending" && (<><Loader2 size={48} className="mx-auto text-amber-500" /><h1 className="font-heading text-3xl font-extrabold mt-6">Paiement en traitement</h1><p className="text-gray-500 mt-3">Votre paiement est en cours de confirmation. Vous recevrez un courriel sous peu.</p><Link to="/" className="inline-block mt-8 text-brand-red font-semibold">Retour à l'accueil</Link></>)}
      {status === "error" && (<><XCircle size={48} className="mx-auto text-red-500" /><h1 className="font-heading text-3xl font-extrabold mt-6">Un problème est survenu</h1><Link to="/panier" className="inline-block mt-8 text-brand-red font-semibold">Retour au panier</Link></>)}
    </div>
  );
}
